module.exports = __webpack_public_path__ + "f02a2a55feae24d317387058c21fc945.svg";